import introJs from 'intro.js';
import {storageAvailable} from '../utils.js'

export default class TourButton extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    return false; // disable functionality for now

    if (document.querySelector('[data-intro]')) {
      this.classList.add('a');
      this.initialButtonText();

      this.addEventListener('click', async e => {
        e.preventDefault();
        e.stopPropagation();

        const tour = await this.startTour();

        if (storageAvailable('localStorage')) {
          this.tourStatus = 'running';

          localStorage.setItem('tour:current', this.resource);
          this.initialButtonText();

          tour.onChange(function() {
            // console.log('change');
            localStorage.setItem('tour:current:step', this.getCurrentStep());
            return true
          });

          tour.oncomplete(function() {
            // console.log('complete');
            this.tourStatus = 'completed';
            localStorage.removeItem('tour:current');
            localStorage.removeItem('tour:current:step');
            this.initialButtonText();
            return true;
          }.bind(this));

          tour.onExit(function() {
            // console.log('exit');
            // localStorage.setItem(this.statusKey, '');
          }.bind(this));
          tour.refresh(true);
          await tour.goToStepNumber(this.currentStep + 1);
        }
      }, true);
    }
  }

  startTour() {
    return introJs.tour().setOptions({
      tooltipClass: 'box box-orange without-actions',
      showBullets: false,
      nextLabel: window.I18n.t('js.tour.next'),
      prevLabel: window.I18n.t('js.tour.previous'),
      doneLabel: window.I18n.t('js.tour.done'),
    }).start();
  }

  get currentStep() {
    const str = localStorage.getItem('tour:current:step') || '0'
    return parseInt(str);
  }

  initialButtonText() {
    if (!this.tourStatus) {
      this.innerHTML = `<img src="${this.getAttribute('icon')}" class="icon"/> Seite erklären`;
    } else if (localStorage.getItem(this.statusKey) == 'running') {
      this.innerHTML = `<img src="${this.getAttribute('icon')}" class="icon"/> Einführung fortsetzen: ${this.resource}`;
    } else {
      this.innerHTML = `<img src="${this.getAttribute('icon')}" class="icon"/> Einführung wiederholen`;
    }
  }

  get resource() {
    return this.getAttribute('resource');
  }

  get statusKey() {
    `tour:status:${this.resource}`
  }

  set tourStatus(str) {
    localStorage.setItem(this.statusKey, str);
  }

  get tourStatus() {
    return localStorage.getItem(this.statusKey);
  }
}
